export default "__VITE_ASSET__BZ_MGn_Y__"